
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  const heroEmailInput = document.querySelector('[data-hero-email-input]');
  const heroUpdatesInput = document.querySelector('[data-hero-updates-input]');
  const ctaEmailInput = document.querySelector('[data-cta-email-input]');
  const ctaTermsInput = document.querySelector('[data-cta-terms-input]');
  const ctaConsentInput = document.querySelector('[data-cta-consent-input]');
  const ctaSection = document.getElementById('waitlist') || document.querySelector('.cta');
  const waitlistSuccessModal = document.querySelector('[data-waitlist-success-modal]');
  const waitlistSuccessCloseButtons = document.querySelectorAll('[data-waitlist-success-close]');
  const heroEmailStorageKey = 'eilipHeroEmail';
  const heroTermsStorageKey = 'eilipTermsAccepted';
  const heroUpdatesStorageKey = 'eilipUpdatesAccepted';
  let waitlistModalLastFocus = null;

  function saveHeroEmail(email) {
    try {
      window.sessionStorage.setItem(heroEmailStorageKey, email);
    } catch (error) {
      // Storage can be unavailable in strict privacy modes; the form should still submit.
    }
  }

  function getSavedHeroEmail() {
    try {
      return window.sessionStorage.getItem(heroEmailStorageKey) || '';
    } catch (error) {
      return '';
    }
  }

  function clearSavedHeroEmail() {
    try {
      window.sessionStorage.removeItem(heroEmailStorageKey);
      window.sessionStorage.removeItem(heroTermsStorageKey);
      window.sessionStorage.removeItem(heroUpdatesStorageKey);
    } catch (error) {
      // Nothing to clear when storage is unavailable.
    }
  }

  function saveHeroTermsAccepted() {
    try {
      window.sessionStorage.setItem(heroTermsStorageKey, 'true');
    } catch (error) {
      // Storage can be unavailable in strict privacy modes; the form should still submit.
    }
  }

  function getSavedHeroTermsAccepted() {
    try {
      return window.sessionStorage.getItem(heroTermsStorageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function saveHeroUpdatesAccepted(accepted) {
    try {
      if (accepted) {
        window.sessionStorage.setItem(heroUpdatesStorageKey, 'true');
      } else {
        window.sessionStorage.removeItem(heroUpdatesStorageKey);
      }
    } catch (error) {
      // Storage can be unavailable in strict privacy modes; the form should still submit.
    }
  }

  function getSavedHeroUpdatesAccepted() {
    try {
      return window.sessionStorage.getItem(heroUpdatesStorageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function setLoopsFormMessage(form, message, type) {
    const messageEl = form.querySelector('[data-loops-form-message]');
    if (!messageEl) return;

    messageEl.textContent = message;
    messageEl.hidden = false;
    messageEl.classList.toggle('success', type === 'success');
    messageEl.classList.toggle('error', type === 'error');
  }

  function openWaitlistSuccessModal() {
    if (!waitlistSuccessModal) return false;

    waitlistModalLastFocus = document.activeElement;
    waitlistSuccessModal.hidden = false;
    document.documentElement.classList.add('waitlist-modal-open');
    document.body.classList.add('waitlist-modal-open');

    const closeButton = waitlistSuccessModal.querySelector('[data-waitlist-success-close]');
    if (closeButton) {
      closeButton.focus({ preventScroll: true });
    }

    return true;
  }

  function closeWaitlistSuccessModal() {
    if (!waitlistSuccessModal || waitlistSuccessModal.hidden) return;

    waitlistSuccessModal.hidden = true;
    document.documentElement.classList.remove('waitlist-modal-open');
    document.body.classList.remove('waitlist-modal-open');

    if (waitlistModalLastFocus && typeof waitlistModalLastFocus.focus === 'function') {
      waitlistModalLastFocus.focus({ preventScroll: true });
    }
  }

  function submitWorkerForm(form, options) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const submitButton = form.querySelector('button[type="submit"]');
      const successMessage = form.dataset.successMessage || 'Thank you - you are on the waitlist.';
      const errorMessage = form.dataset.errorMessage || 'Sorry, something went wrong. Please try again.';
      const originalButtonText = submitButton ? submitButton.textContent : '';
      const payload = new URLSearchParams(new FormData(form));
      const loadingText = options && options.loadingText ? options.loadingText : 'Joining...';

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = loadingText;
      }

      fetch(form.action, {
        method: 'POST',
        mode: 'cors',
        body: payload,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Waitlist submission failed');
          }

          if (options && typeof options.onSuccess === 'function') {
            options.onSuccess(form, successMessage);
          } else {
            clearSavedHeroEmail();
            setLoopsFormMessage(form, successMessage, 'success');
            form.reset();
          }
        })
        .catch(function () {
          setLoopsFormMessage(form, errorMessage, 'error');
        })
        .finally(function () {
          if (!submitButton) return;
          submitButton.disabled = false;
          submitButton.textContent = originalButtonText;
        });
    });
  }

  function submitLoopsForm(form) {
    if (!form.matches('[data-loops-waitlist-form]')) return;

    submitWorkerForm(form, {
      onSuccess: function (form, successMessage) {
        clearSavedHeroEmail();
        form.reset();

        if (window.history && window.history.pushState) {
          window.history.pushState(null, '', '#waitlist');
        } else {
          window.location.hash = 'waitlist';
        }

        if (!openWaitlistSuccessModal()) {
          setLoopsFormMessage(form, successMessage, 'success');
        }
      }
    });
  }

  waitlistSuccessCloseButtons.forEach(function (button) {
    button.addEventListener('click', closeWaitlistSuccessModal);
  });

  if (heroEmailInput && ctaEmailInput && ctaSection) {
    const heroForm = heroEmailInput.closest('form');
    const ctaForm = ctaEmailInput.closest('form');
    const savedHeroEmail = getSavedHeroEmail();

    if (savedHeroEmail && !ctaEmailInput.value) {
      ctaEmailInput.value = savedHeroEmail;
      ctaEmailInput.dispatchEvent(new Event('input', { bubbles: true }));
      ctaEmailInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (ctaTermsInput && getSavedHeroTermsAccepted()) {
      ctaTermsInput.checked = true;
      ctaTermsInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (ctaConsentInput && getSavedHeroUpdatesAccepted()) {
      ctaConsentInput.checked = true;
      ctaConsentInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (savedHeroEmail && window.location.hash === '#waitlist') {
      window.setTimeout(function () {
        const nextInput = ctaSection.querySelector('input[name="firstName"]') || ctaEmailInput;
        nextInput.focus({ preventScroll: true });
      }, 350);
    }

    if (heroForm) {
      submitWorkerForm(heroForm, {
        loadingText: 'Saving...',
        onSuccess: function (form) {
          const successMessage = form.dataset.successMessage || 'Thank you - you are on the waitlist.';
          const email = heroEmailInput.value.trim();

          if (email) {
            saveHeroEmail(email);
            saveHeroTermsAccepted();
            saveHeroUpdatesAccepted(heroUpdatesInput && heroUpdatesInput.checked);
            ctaEmailInput.value = email;
            ctaEmailInput.dispatchEvent(new Event('input', { bubbles: true }));
            ctaEmailInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          if (ctaTermsInput) {
            ctaTermsInput.checked = true;
            ctaTermsInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          if (ctaConsentInput && heroUpdatesInput && heroUpdatesInput.checked) {
            ctaConsentInput.checked = true;
            ctaConsentInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          setLoopsFormMessage(form, successMessage, 'success');

          if (window.history && window.history.pushState) {
            window.history.pushState(null, '', '#waitlist');
          } else {
            window.location.hash = 'waitlist';
          }

          ctaSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

          window.setTimeout(function () {
            const nextInput = ctaSection.querySelector('input[name="firstName"]') || ctaEmailInput;
            nextInput.focus({ preventScroll: true });
          }, 650);
        }
      });
    }

    if (ctaForm) {
      submitLoopsForm(ctaForm);
    }
  }

  if (!toggle || !drawer) return;

  function setDrawer(open) {
    drawer.classList.toggle('is-open', open);
    toggle.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  toggle.addEventListener('click', function () {
    setDrawer(!drawer.classList.contains('is-open'));
  });

  drawer.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      setDrawer(false);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeWaitlistSuccessModal();
    if (event.key === 'Escape') setDrawer(false);
  });

  document.addEventListener('click', function (event) {
    if (!drawer.classList.contains('is-open')) return;
    if (drawer.contains(event.target) || toggle.contains(event.target)) return;
    setDrawer(false);
  });
});
